import * as React from 'react';
import cn from 'clsx';
import { useDeviceType } from '@cian/ui-kit/responsive';
import { TDeviceType } from '@cian/ui-kit';

import { Sticky } from '../../packages/Sticky';

import * as styles from './styles.css';

export interface IStickyActions {
  deviceTypesWithSticky?: TDeviceType[];
  testId?: string;
}
export const StickyActions: React.FC<React.PropsWithChildren<IStickyActions>> = props => {
  const { children, deviceTypesWithSticky, testId } = props;
  const [isBottomStuck, setIsBottomStuck] = React.useState(false);
  const deviceType = useDeviceType();
  const withSticky = deviceTypesWithSticky ? deviceTypesWithSticky.includes(deviceType) : true;

  if (withSticky) {
    const zIndex = isBottomStuck ? 10 : undefined;
    const classNames = cn(styles['action-area'], {
      [styles['action-area-is-sticky']]: isBottomStuck,
    });

    return (
      <Sticky zIndex={zIndex} onBottomStuck={setIsBottomStuck} testId={testId}>
        <div className={styles['action-wrapper']}>
          <div className={classNames}>{children}</div>
        </div>
      </Sticky>
    );
  }

  return <div className={styles['action-area']}>{children}</div>;
};

StickyActions.displayName = 'StickyActions';
